<template>
  <div class="g-wrapper">
    <router-view/>

    <b-modal
      class="g-modal"
      v-model="globalModal.isOpen"
      :title="globalModal.modelTitle"
      :ok-title="globalModal.okTitle"
      :cancel-title="globalModal.cancelTitle"
      id="globalModal"
      :ok-only="globalModal.okOnly">
      {{globalModal.modelContent}}
    </b-modal>

  </div>
</template>

<script>
import { mapGetters} from 'vuex';

export default {

  components: {

  },

  props: [""],

  data () {
    return {
      show:true
    }
  },

  created () {

  },

  mounted () {

  },

  activated () {

  },

  updated () {

  },

  beforeUpdate () {

  },

  methods: {

  },

  filters: {

  },

  computed: {
    ...mapGetters([
      'globalModal',
    ])
  },

  watch: {

  },

  destroyed () {

  }

}
</script>

<style lang="less" scoped>
@import url("./assets/css/z-0.6.less");
.g-wrapper{
  height: 100%;
}
</style>




// WEBPACK FOOTER //
// src/App.vue